// @flow strict

import { createContext } from 'react';

export default createContext<?{ [number]: { x: number }}>();
